import { REFERENCE_PEPTIDES } from "@/lib/research/peptides-reference";
import type { ReferencePeptide } from "@/lib/research/types";
import { getProductPathForPeptide } from "@/lib/research/saleor-product-map";
import { localizeReferencePeptide } from "@/lib/research/localized-reference";

/** Maps a live Saleor product slug to the matching reference-peptide row, if any. */
export function getReferencePeptideForProductSlug(
	productSlug: string,
	locale?: string,
): ReferencePeptide | undefined {
	const direct = REFERENCE_PEPTIDES.find((p) => p.slug === productSlug);
	if (direct) return localizeReferencePeptide(direct, locale);

	const mapped = REFERENCE_PEPTIDES.find((p) => {
		const path = getProductPathForPeptide(p.slug);
		return path === `/products/${productSlug}`;
	});
	return mapped ? localizeReferencePeptide(mapped, locale) : undefined;
}
